import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import EbookDownloadButton from "../components/ebook/EbookDownloadButton";
import { fetchMyEbookDownloads } from "../api/ebookApi";
import { assetUrl } from "../utils/api";

function formatDateTime(value) {
  if (!value) return "—";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return value;
  return date.toLocaleString("zh-CN", { hour12: false });
}

export default function MyEbookDownloads() {
  const userId = localStorage.getItem("user_id") || "";
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    if (!userId) return;
    setLoading(true);
    fetchMyEbookDownloads(userId)
      .then((data) => {
        setItems(data.items || []);
        setError("");
      })
      .catch((err) => {
        setItems([]);
        setError(err.message || "加载失败");
      })
      .finally(() => setLoading(false));
  }, [userId]);

  return (
    <div className="space-y-6">
      <header>
        <h1 className="text-2xl font-bold text-gray-800">📚 我的下载</h1>
        <p className="text-sm text-gray-500 mt-1">查看已下载的电子书，支持再次下载。</p>
      </header>

      {loading ? (
        <p className="text-gray-400 py-10 text-center">加载中...</p>
      ) : error ? (
        <p className="text-red-500 py-10 text-center">{error}</p>
      ) : items.length === 0 ? (
        <div className="rounded-2xl border border-dashed border-gray-200 p-10 text-center space-y-4">
          <p className="text-gray-400">还没有下载记录</p>
              <Link to="/book-club?tab=ebooks" className="text-pink-600 hover:underline">
                去读书会 · 电子书看看 →
              </Link>
        </div>
      ) : (
        <div className="space-y-4">
          {items.map(({ download_id, downloaded_at, ebook }) => (
            <article
              key={download_id}
              className="rounded-2xl border border-gray-100 p-4 md:p-5 flex flex-col md:flex-row gap-4 md:items-center"
            >
              <Link to={`/ebooks/${ebook.id}`} className="flex items-center gap-4 flex-1 min-w-0">
                {ebook.cover_path ? (
                  <img
                    src={assetUrl(ebook.cover_path)}
                    alt={ebook.title}
                    className="w-16 h-20 rounded-lg object-cover shrink-0"
                  />
                ) : (
                  <div className="w-16 h-20 rounded-lg bg-pink-50 flex items-center justify-center text-2xl shrink-0">
                    📚
                  </div>
                )}
                <div className="min-w-0">
                  <h2 className="font-semibold text-gray-800 truncate">{ebook.title}</h2>
                  <p className="text-sm text-gray-500 mt-1">
                    作者：{ebook.author || "未知"}
                  </p>
                  <p className="text-xs text-gray-400 mt-1">
                    下载时间：{formatDateTime(downloaded_at)}
                  </p>
                </div>
              </Link>
              <EbookDownloadButton ebook={ebook} userId={userId} size="sm" />
            </article>
          ))}
        </div>
      )}
    </div>
  );
}
